import { convertToObjById } from "helpers/convertToObject";
import { BRANDS_METERS_TYPES } from "./brandsMetersTypes";
import { sortLinkedDropdown } from "helpers/sortDropdown";
import { normalizedSubArray } from "helpers/normalizedSubArray";

const {
  SET_BRANDS_METERS_NEW,
  MODELS_BY_BRANDS_METERS,
  NEW_BRAND_MODEL,
  UPSERT_BRAND_MODEL,
  EDIT_BRAND_MODEL,
  CLEAR_BRAND_MODEL
} = BRANDS_METERS_TYPES;

const initialState = {
  brands: {},
  brandsList: [],
  models: {},
  modelsList: [],
  error: null,
  modelsByBrand: []
};

export const brandsMetersReducer = (
  state = initialState,
  { payload, type }
) => {
  switch (type) {
    case CLEAR_BRAND_MODEL:
      return {
        ...state,
        ...initialState
      };

    case SET_BRANDS_METERS_NEW: {
      const { brands } = payload;

      const addingLabel = brands.map(brand => {
        return {
          ...brand,
          models: brand.models.map(model => {
            return {
              ...model,
              label: model.name,
              value: model.id,
              idBrand: brand.id,
              brand: brand.name,
              fullName: `${brand.name} - ${model.name}`
            };
          })
        };
      });

      const newBrands = sortLinkedDropdown(addingLabel);
      const newModels = normalizedSubArray(addingLabel, "models");

      return {
        ...state,
        brands: convertToObjById(addingLabel),
        models: convertToObjById(newModels),
        modelsList: newModels,
        brandsList: newBrands
      };
    }

    case MODELS_BY_BRANDS_METERS:
      console.log(payload);
      console.log(state.brandsList.filter(item => item.id === payload));

      return {
        ...state,
        modelsByBrand: state.brandsList.filter(item => item.id === payload)[0]
          .models
      };

    case EDIT_BRAND_MODEL:
      return {
        ...state,
        isAddMode: false,
        isDeleteMode: false,
        editModel: payload && state.models[payload]
      };

    case NEW_BRAND_MODEL:
      return {
        ...state,
        isAddMode: true,
        isDeleteMode: false
      };

    case UPSERT_BRAND_MODEL: {
      const newBrand = state.brands[payload.id] || payload;
      newBrand.name = payload.name;
      state.brands[newBrand.id] = newBrand;

      const newModel =
        newBrand.models.find(_ => _.id == payload.models[0].id) ||
        payload.models[0];
      newModel.name = payload.models[0].name;
      const labelModel = {
        ...newModel,
        label: newModel.name,
        value: newModel.id,
        idBrand: newBrand.id,
        brand: newBrand.name,
        fullName: `${newBrand.name} - ${newModel.name}`
      };

      newBrand.models = newBrand.models.filter(_ => _.id != labelModel.id);
      newBrand.models.push(labelModel);

      state.brandsList = state.brandsList.filter(_ => _.id != newBrand.id);
      state.brandsList.push({
        ...newBrand,
        label: newBrand.name,
        value: newBrand.id
      });

      state.modelsList = state.modelsList.filter(_ => _.id != labelModel.id);
      state.modelsList.push(labelModel);
      state.models[labelModel.id] = labelModel;

      return state;
    }

    default:
      return state;
  }
};
